import { Component, OnInit } from '@angular/core'
import { MainService } from '../../service/main.service'

@Component({
	selector: 'gw-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['../comment.component.styl']
})

export class FooterComponent implements OnInit{
	item1_list: Array<any>;
	telphone: string;
	e_mail: string;
	weixin: string;
	constructor(public mainService: MainService){}
	ngOnInit() {
		this.mainService.getCommentData()
		.subscribe(
			data=>{
				this.item1_list = data.footer_list;
				this.telphone = data.telphone;
				this.e_mail = data.e_mail;
				this.weixin = data.weixin;
			},
			error=>{
				console.log(error)
			}
		)
	}
}


// WEBPACK FOOTER //
// C:/Users/Administrator/submit text project/gwin/src/app/comment/footer/footer.component.ts